import { FC, ReactNode } from 'react';
import { CodeSample, CodeSampleNavigation } from '@getstream/ui-library/build';

import CodeFooter from '../CodeFooter';

import styles from './Code.module.css';

export type Props = {
  language: string;
  footer?: {
    run: () => void;
    disabled?: boolean;
    label: string;
  };
  wrapLongLines?: boolean;
  children: ReactNode | undefined;
};

export const Code: FC<Props> = ({
  children,
  language,
  wrapLongLines,
  footer,
}) => {
  return (
    <CodeSampleNavigation
      Footer={footer ? () => <CodeFooter {...footer} /> : undefined}
    >
      <CodeSample
        minHeight={false}
        customClass={styles.code}
        language={language}
        wrapLongLines={wrapLongLines}
      >
        {children}
      </CodeSample>
    </CodeSampleNavigation>
  );
};
